"use client";

import { truncateTextForPreview } from "@/helpers/cleanMetadataText";
import { BlogPost } from "@/lib/blogPosts";
import { useMessages } from "@/lib/i18n/useMessages";
import { slRoutes } from "@/lib/slRoutes";
import { getTeamMembersRecord } from "@/lib/teamData";
import { SLHtmlFromLangFile } from "../sections/home/SLHtmlFromLangFile";
import { SLPreviewCard } from "./SLPreviewCard";

interface SLBlogPreviewCardProps {
  post: BlogPost;
  titleMaxLength?: number;
}

export const SLBlogPreviewCard = ({
  post,
  titleMaxLength,
}: SLBlogPreviewCardProps) => {
  const teamRecord = getTeamMembersRecord(useMessages().team);

  const authors = post.hideAuthorInHeader
    ? undefined
    : post.authors.map((author) => ({
        id: author,
        name: teamRecord[author].fullName,
        image: teamRecord[author].image[600],
      }));

  const title = titleMaxLength
    ? truncateTextForPreview(post.title, titleMaxLength)
    : post.title;

  return (
    <SLPreviewCard
      href={post.href || slRoutes.blogPost(post.slug)}
      title={<SLHtmlFromLangFile htmlString={title} />}
      summary={post.summary[0]}
      authors={authors}
      date={post.formattedDate}
    />
  );
};
